import { render, staticRenderFns } from "./repairers.vue?vue&type=template&id=1be32644"
import script from "./repairers.vue?vue&type=script&lang=js"
export * from "./repairers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports